import { APP_SAVE_BAR_SCOPE } from "@/modules/app-save-bar";

export const ASSET_TYPE_SEVERITY_GRID_SCOPE =
  APP_SAVE_BAR_SCOPE.ASSET_TYPE_SEVERITY_GRID_EDITOR;
